<form [formGroup]="formGroup" (submit)="submit()">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'reporting_CHANGE_ACCOUNT_PERIOD' | translate }}</h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cancel')"></button>
    </div>

    <div class="modal-body">
        <app-input-date-group
            [label]="'reporting_START_DATE' | translate"
            [required]="true"
            formControlName="startDate" />
        <app-input-date-group
            [label]="'reporting_END_DATE' | translate"
            [required]="true"
            formControlName="endDate" />
        <div class="offset-4">
            <app-control-messages [control]="formGroup"></app-control-messages>
        </div>

        @if (accountPeriodWarnings$ | async; as warnings) {
            <div>
                @if (warnings.periodWarning6Months) {
                    <div class="text-warning-emphasis w-100">
                        {{ 'reporting_FINAL_INVOICE_WARNING_PERIOD_6_MONTH_SHORTER' | translate }}
                    </div>
                }
                @if (warnings.periodWarning18Months) {
                    <div class="text-warning-emphasis w-100">
                        {{ 'reporting_FINAL_INVOICE_WARNING_PERIOD_18_MONTH_LONGER' | translate }}
                    </div>
                }
                @if (warnings.startDateIsNotTheDayAfterThePreviousAccountingPeriod) {
                    <div class="text-warning-emphasis w-100">
                        {{
                            'reporting_FINAL_INVOICE_WARNING_NEW_START_NOT_SUBSEQUENT_DAY'
                                | translate
                        }}
                    </div>
                }
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary">
            {{ 'reporting_SAVE' | translate }}
        </button>
    </div>
</form>
